import type { ReactNode } from "react";

/** The HobbyScan app's store pages, as the public site links them (`hobbyshop.ai/lib/site.ts`). */
const APP_STORE_URL = "https://apps.apple.com/app/id6744403125";
const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.hobbyscan.app";

/** One link for both phones: Google Play on Android, the App Store everywhere else, as the site's `GetAppLink`. */
const appStoreUrl = (userAgent: string): string => (/android/i.test(userAgent) ? PLAY_STORE_URL : APP_STORE_URL);

/** Small type where the browser cannot do what the app does, with one link that picks the phone's store. */
export function AppPrompt({ children }: { children: ReactNode }) {
  const href = appStoreUrl(typeof navigator === "undefined" ? "" : navigator.userAgent);
  return (
    <p className="text-center text-xs text-faint">
      {children}{" "}
      <a href={href} target="_blank" rel="noreferrer" className="text-accent underline">
        Download the app
      </a>
    </p>
  );
}
